import { FullReportEntry, gap } from "../../models/FullReportEntry";


export function totalCostStyle(a:FullReportEntry){
    if(a.expectedBudged == 0) return ""
    var ratio = a.overrun;
    if(ratio > 1.15) return "bg-light-danger"
    if(ratio < 0.8) return "bg-light-danger"
    if(ratio < 0.95) return "bg-light-warning"
    return "bg-light-success"
}

export function leadGoalStyle(a:FullReportEntry){
    const mg = a.goalRatio || 0;
    if(mg >= 1) return 'bg-light-success';
    if(mg < .7) return 'bg-light-danger';
    return 'bg-light-warning'
}

export function gapStyle(a:FullReportEntry){
    const g = gap(a);
    if(g >= 0) return 'bg-light-success';
    if(g < a.dayGoal * 3) return 'bg-light-danger';
    return 'bg-light-warning'
}

